/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.cookie = function () {
    class Cookie {
      constructor(target, button) {
        this.target = target;
        this.button = button;
        this.fetchDom();
        this.check();
      }

      fetchDom() {
        this.targetEle = $(this.target);
        this.buttonEle = $(this.button);
      }

      check() {
        if (!this.targetEle || !this.buttonEle) {
          return false;
        }

        if (sessionStorage.getItem('cookie')){
          this.targetEle.addClass("is-hide");
        }

        this.run();
      }

      run() {
        this.buttonEle.on("click", () => {
          this.targetEle.addClass("is-hide");
          sessionStorage.setItem('cookie', true);
        });
      }
    }
    new Cookie("#cookie", ".c-block-cookie__button");
  };

  $(function () {
    var app = new growApp();
    app.cookie();
  });
})(jQuery);
